/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PlacementType;

(function (PlacementType) {
  PlacementType["ARCHITECTS_ENGINEER_SURVEYORS"] = "architects_engineer_surveyors";
  PlacementType["CLERICAL"] = "clerical";
  PlacementType["DRIVERS"] = "drivers";
  PlacementType["IT_TECH"] = "it_tech";
  PlacementType["MANUAL_TRADES"] = "manual_trades";
  PlacementType["MEDICAL"] = "medical";
  PlacementType["RAIL_AND_OFFSHORE"] = "rail_and_offshore";
  PlacementType["SECURITY_PERSONNEL"] = "security_personnel";
  PlacementType["WAREHOUSE_MANUFACTURING"] = "warehouse_manufacturing";
  PlacementType["WHITE_COLLAR"] = "white_collar";
  PlacementType["OTHER"] = "other";
})(PlacementType || (PlacementType = {}));